<template>
  <RecentClaims v-if="isRecentClaims" v-bind="$attrs" v-on="$listeners" />
  <UsedBenefitsDashboardItemSbaLegacy
    v-else-if="isLegacy"
    v-bind="$attrs"
    v-on="$listeners"
  />
  <UsedBenefitsDashboardItemSba v-else v-bind="$attrs" v-on="$listeners" />
</template>

<script>
import { mapGetters } from "vuex";
import UsedBenefitsDashboardItemSbaLegacy from "./UsedBenefitsDashboardItemSbaLegacy";
import UsedBenefitsDashboardItemSba from "./UsedBenefitsDashboardItemSba";
import RecentClaims from "./RecentClaims";
export default {
  components: {
    UsedBenefitsDashboardItemSbaLegacy,
    UsedBenefitsDashboardItemSba,
    RecentClaims,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters("common", ["useLegacyClaims", "userProfile"]),
    isLegacy() {
      return this.useLegacyClaims;
    },
    isRecentClaims() {
      return this.hasHealthLifestyle || this.memberHasOnlySpendingAccounts;
    },
    hasHealthLifestyle() {
      let result = false;
      if (!this.userProfile) {
        return result;
      }
      this.userProfile?.Coverages?.forEach((coverage) => {
        if (
          coverage?.CoverageIdentity?.CoverageType === "Health" &&
          coverage?.CurrentBenefit?.Name?.toLowerCase().includes("lifestyle")
        ) {
          result = true;
        }
      });
      return result;
    },
    memberHasOnlySpendingAccounts() {
      if (!this.userProfile) {
        return false;
      }
      return !this.userProfile?.Coverages?.some(
        (o) => !o.IsHSA && !o.IsWellness
      );
    },
  },
};
</script>
